module.exports = __webpack_public_path__ + "img/watch_tab_large.5894fcac.webp";